import React, { useState, useEffect } from "react";

const AuthLoadingOverlay = ({ message = "Loading...", onRetry }) => {
  const [showRetry, setShowRetry] = useState(false);

  useEffect(() => {
    // Show retry button after 10 seconds if still loading
    const timer = setTimeout(() => {
      setShowRetry(true);
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "white",
          borderRadius: "8px",
          padding: "40px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div
          style={{
            border: "4px solid #f3f3f3",
            borderTop: "4px solid #3498db",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            animation: "spin 1s linear infinite",
            marginBottom: "20px",
          }}
        />
        <p
          style={{
            margin: 0,
            fontSize: "16px",
            color: "#333",
            fontWeight: "500",
          }}
        >
          {message}
        </p>

        {(showRetry || onRetry) && onRetry && (
          <div style={{ marginTop: "25px" }}>
            {!showRetry && (
              <p
                style={{
                  margin: "0 0 15px 0",
                  fontSize: "12px",
                  color: "#999",
                }}
              >
                Having trouble? You can try again:
              </p>
            )}
            {showRetry && (
              <p
                style={{
                  margin: "0 0 15px 0",
                  fontSize: "12px",
                  color: "#999",
                }}
              >
                Taking longer than expected?
              </p>
            )}
            <button
              onClick={onRetry}
              style={{
                padding: "10px 20px",
                backgroundColor: "#3498db",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "500",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#2980b9")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#3498db")}
            >
              Try Again
            </button>
          </div>
        )}

        {onRetry && (
          <p
            style={{
              margin: "30px 0 0 0",
              fontSize: "12px",
              color: "#999",
              textAlign: "center",
            }}
          >
            Stuck on the login screen?{" "}
            <button
              onClick={onRetry}
              style={{
                background: "none",
                border: "none",
                color: "#3498db",
                cursor: "pointer",
                fontSize: "12px",
                textDecoration: "underline",
                padding: 0,
              }}
              onMouseOver={(e) => (e.target.style.color = "#2980b9")}
              onMouseOut={(e) => (e.target.style.color = "#3498db")}
            >
              Go back
            </button>
          </p>
        )}

        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default AuthLoadingOverlay;
